import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import LanguageSwitcher from '../common/LanguageSwitcher';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const { t } = useTranslation(['auth', 'common']);
  const [secretKey, setSecretKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Auto-login if secret key is provided via URL parameter
  useEffect(() => {
    const keyParam = searchParams.get('key');
    if (keyParam) {
      setLoading(true);
      login(keyParam).then((result) => {
        if (result.success) {
          navigate('/queue', { replace: true });
        } else {
          setError(result.error || t('errors.invalidKey', { ns: 'common' }));
          setLoading(false);
        }
      }).catch(() => {
        setError(t('errors.generic', { ns: 'common' }));
        setLoading(false);
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(secretKey);

      if (result.success) {
        navigate('/queue');
      } else {
        setError(result.error || t('errors.invalidKey', { ns: 'common' }));
      }
    } catch (err) {
      setError(t('errors.generic', { ns: 'common' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="https://accesso.com/wp-content/uploads/2025/10/03-horizontal-full-color-1-e1761242891116.png" alt="accesso" className="login-logo" />
          <h1>{t('title', { ns: 'auth' })}</h1>
          <p>{t('subtitle', { ns: 'auth' })}</p>
        </div>

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="secretKey" className="input-label">
              {t('keyLabel', { ns: 'auth' })}
            </label>
            <input
              id="secretKey"
              type="password"
              value={secretKey}
              onChange={(e) => setSecretKey(e.target.value)}
              placeholder={t('keyPlaceholder', { ns: 'auth' })}
              required
              className="input"
              autoFocus
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? t('connecting', { ns: 'auth' }) : t('connectButton', { ns: 'auth' })}
          </button>
        </form>

        <div className="login-language-switcher">
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  );
};

export default Login;
